import React from "react";
import classNames from "classnames";
import { MenuItem } from "@blueprintjs/core";
import { NoUnitsType } from "store/recipe/recipe.types";
import * as styles from "./styles.module.scss";
export const renderParameterUnitsAdditionalListItem = (renderer) => {
    const { filteredItems } = renderer;
    const filteredRenderedItems = filteredItems.filter(({ isGroupName }) => !isGroupName);
    if (filteredRenderedItems.length <= 1 && filteredRenderedItems[0]?.value === NoUnitsType.NoUnits) {
        return (React.createElement(MenuItem, { disabled: true, key: filteredRenderedItems.length, text: React.createElement("p", { className: classNames(styles.item, styles["item-noMatch"]) }, "No matching units.") }));
    }
    else {
        return undefined;
    }
};
export const parameterUnitsItemPredicate = (query, item) => {
    const normalizedQuery = query.toLowerCase();
    if (item.isGroupName || item.value === NoUnitsType.NoUnits) {
        return true;
    }
    if ("searchVariants" in item) {
        const { searchVariants } = item;
        return !!searchVariants?.some((variant) => variant.toLowerCase().includes(normalizedQuery));
    }
    else {
        return false;
    }
};
export const customVariableRelativeValueListPredicate = (query, items) => {
    const normalizedQuery = query.toLowerCase();
    if (!normalizedQuery) {
        return items;
    }
    return items.reduce((acc, item) => {
        const matchesQuery = !!normalizedQuery && item?.label.toLowerCase().includes(normalizedQuery);
        const matchingItemGroupNameItem = matchesQuery && items.find(({ isGroupName, category }) => isGroupName && item?.category === category);
        if (!matchesQuery) {
            return acc;
        }
        const bulk = [item];
        if (!!matchingItemGroupNameItem &&
            !acc.includes(matchingItemGroupNameItem) &&
            !bulk.includes(matchingItemGroupNameItem)) {
            bulk.unshift(matchingItemGroupNameItem);
        }
        return [...acc, ...bulk];
    }, []);
};
